"use client";

import {
  Box,
  Flex,
  Heading,
  TableContainer,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
} from "@chakra-ui/react";
import Image from "next/image";
import { useSectionHeadingVariant } from "@/theme/components/useSectionHeading";
import { ISV_DESKTOP_DATA } from "./constants";
import PricingFooter from "./pricingfooter";

const ISVDesktopTable = () => {
  const HeadingVariant = useSectionHeadingVariant();
  return (
    <Box id="pricing">
      <Heading variant={HeadingVariant} mb={8} textAlign={"center"}>
        ISV Desktop Pricing
      </Heading>
      <TableContainer>
        <Table variant="striped" border="2px solid rgb(237,242,247)" width={"100%"}>
          <Thead>
            <Tr>
              <Th textAlign={"center"}>Processor</Th>
              <Th textAlign={"center"}>Memory</Th>
              <Th textAlign={"center"}>Base Clock | Boost</Th>
              <Th textAlign={"center"}>Disk</Th>
              <Th textAlign={"center"}>GPU</Th>
              <Th textAlign={"center"}>Pricing (Linux)</Th>
            </Tr>
          </Thead>
          <Tbody>
            {ISV_DESKTOP_DATA.map((desktop, index) => (
              <Tr key={index}>
                <Td textAlign={"center"}>
                  {" "}
                  <Box
                    display={"flex"}
                    alignItems={"center"}
                    flexDirection={"row"}
                    gap={"6px"}
                  >
                    <Box
                      h="2rem"
                      position="relative"
                      w="2rem"
                      display={"flex"}
                      alignItems={"center"}
                      gap="2px"
                    >
                      <Image
                        src={desktop.image}
                        alt="image"
                        style={{ objectFit: "contain" }}
                      />
                    </Box>
                    <Flex direction={"column"} style={{ whiteSpace: "nowrap" }}>
                      <Box>{desktop.processor}</Box>
                    </Flex>
                  </Box>
                </Td>
                <Td textAlign={"center"}>{desktop.memory}</Td>
                <Td textAlign={"center"}>{desktop.baseclock_boost}</Td>
                <Td textAlign={"center"}>{desktop.disk}</Td>
                <Td textAlign={"center"}>{desktop.gpu}</Td>
                <Td textAlign={"center"}>{desktop.price}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
      <PricingFooter />
    </Box>
  );
};

export default ISVDesktopTable;
